import { Text } from "@clayui/core";
import ClayIcon from "@clayui/icon";
import ClaySticker from "@clayui/sticker";
import React from "react";
import { RELATIONSHIP, OBJECT_ENTRY_URL_SEPARATOR } from "../../utils/constants";

const NavigationModuleItem = ({isLessonCompleted, navigationMenuItem}) => {
	const quiz = navigationMenuItem[RELATIONSHIP.MODULES_TO_QUIZZES]?.[0];
	const lesson = navigationMenuItem[RELATIONSHIP.MODULES_TO_LESSONS]?.[0];
	const url = quiz?.id
		? quiz.friendlyUrlPath
			? `/${OBJECT_ENTRY_URL_SEPARATOR.QUIZ}/${quiz.friendlyUrlPath}`
			: null
		: lesson?.friendlyUrlPath
			? `/${OBJECT_ENTRY_URL_SEPARATOR.LESSON}/${lesson.friendlyUrlPath}`
			: null;

	return (
		<div
			className={`d-flex px-3 py-3 lesson-link ${
				isLessonCompleted(
					navigationMenuItem[RELATIONSHIP.MODULES_TO_LESSONS][0].id
				)
					? "completed"
					: "not-completed"
			} ${
				navigationMenuItem[RELATIONSHIP.MODULES_TO_LESSONS][0].active
					? "active"
					: ""
			}`}
		>
			{isLessonCompleted(
				navigationMenuItem[RELATIONSHIP.MODULES_TO_LESSONS][0].id
			) && (
				<div>
					<ClaySticker shape="circle" displayType="primary" size="md">
						<ClayIcon symbol="check" />
					</ClaySticker>
				</div>
			)}
			<span className="module-title my-auto px-2">
				<Text size={4} weight={"semi-bold"}>
					<a
						className="lesson-link"
						style={{ textDecoration: "none" }}
						href={url}
					>
						{navigationMenuItem[RELATIONSHIP.MODULES_TO_LESSONS][0].title === ""
							? navigationMenuItem[RELATIONSHIP.MODULES_TO_LESSONS][0]
									.title_i18n.en_US
							: navigationMenuItem[RELATIONSHIP.MODULES_TO_LESSONS][0].title}
					</a>
				</Text>
			</span>
		</div>
	);
};

export default NavigationModuleItem;
